import {
  LayoutDashboard, Users, Contact, Building2, GitBranch, Activity, MapPin,
  Handshake, BarChart3, Bell, Settings, ScrollText, UserCircle, ListTodo,
} from "lucide-react";

export const ALL_NAV = {
  dashboard: { label: "Dashboard", to: "/dashboard", icon: LayoutDashboard },
  users: { label: "Users & Access", to: "/users", icon: Users },
  leads: { label: "Leads", to: "/leads", icon: Contact },
  accounts: { label: "Accounts", to: "/accounts", icon: Building2 },
  pipeline: { label: "Pipeline", to: "/pipeline", icon: GitBranch },
  activities: { label: "Activities", to: "/activities", icon: Activity },
  tasks: { label: "My Tasks", to: "/activities", icon: ListTodo },
  workmap: { label: "Work Tracking Map", to: "/work-map", icon: MapPin },
  partners: { label: "Partners", to: "/partners", icon: Handshake },
  reports: { label: "Reports", to: "/reports", icon: BarChart3 },
  notifications: { label: "Notifications", to: "/notifications", icon: Bell },
  settings: { label: "Settings", to: "/settings", icon: Settings },
  audit: { label: "Audit Logs", to: "/audit", icon: ScrollText },
  profile: { label: "Profile", to: "/profile", icon: UserCircle },
};

const K = (keys) => keys.map((k) => ALL_NAV[k]);

export const NAV_BY_ROLE = {
  super_admin: K(["dashboard", "users", "leads", "accounts", "pipeline", "activities", "workmap",
    "partners", "reports", "notifications", "settings", "audit"]),
  manager: K(["dashboard", "leads", "accounts", "pipeline", "activities", "workmap", "reports",
    "notifications", "audit", "profile"]),
  field_executive: K(["dashboard", "leads", "accounts", "activities", "workmap", "pipeline",
    "notifications", "profile"]),
  sales_partner: K(["dashboard", "leads", "activities", "pipeline", "notifications", "profile"]),
  telecaller: K(["dashboard", "leads", "activities", "notifications", "profile"]),
  finance_manager: K(["dashboard", "partners", "reports", "notifications", "profile"]),
};

export function navForRole(role) {
  return NAV_BY_ROLE[role] || NAV_BY_ROLE.field_executive;
}

// Route-level guard: which roles may open a top-level path.
export const ROUTE_ROLES = {
  "/users": ["super_admin"],
  "/settings": ["super_admin"],
  "/audit": ["super_admin", "manager"],
  "/partners": ["super_admin", "manager", "finance_manager"],
  "/work-map": ["super_admin", "manager", "field_executive", "telecaller"],
};

export function canAccessPath(role, path) {
  const base = "/" + (path.split("/")[1] || "");
  const allowed = ROUTE_ROLES[base];
  if (!allowed) return true;
  return allowed.includes(role);
}
